import PropTypes from 'prop-types'

import {Map} from 'immutable'

import defaultAdvisorAvatar from '../../../../../shared_assets/default-advisor-avatar.svg'
import {advisorContactCardImage} from '../../../../../lib/advisorContactCardTools'
import {addPossessive} from '../../../../../lib/tools'
import {BoxGutterMedium} from '../../blocks/Boxes'
import {Icon} from '../../../../../shared_components/Icon'
import {TextGutterMedium} from '../../../../../dashboard/src/components/blocks/Texts'

import './providedByInformation.scss'

export const ProvidedByInformation = ({advisorContactCard}) => (
  <BoxGutterMedium className='provided-by-information'>
    <h2>Your Everplan is provided by</h2>
    <div className='provided-by-information-contact-card flex-container'>
      <img
        alt={`${addPossessive(advisorContactCard.get('name'))} image`}
        className='advisor-head-shot flex-child'
        src={
          advisorContactCardImage({
            advisorContactCard,
            defaultImage: defaultAdvisorAvatar
          })
        }
      />
      <div className='contact-information flex-child flex-container'>
        <div className='contact-information-row flex-child name'>
          <strong>{advisorContactCard.get('name')}</strong>
        </div>
        {
          advisorContactCard.get('firm-name') &&
          advisorContactCard.get('firm-type') !== 'funeral_home' &&
          <div className='contact-information-row flex-child'>
            {advisorContactCard.get('firm-name')}
          </div>
        }
        <div className='contact-information-row flex-child'>
          <Icon className='fa-envelope-o' />
          <a href={`mailto:${advisorContactCard.get('email')} `}>
            Send an email
          </a>
        </div>
        {
          advisorContactCard.get('phone') &&
          advisorContactCard.get('firm-type') !== 'funeral_home' &&
          (
            <div className='contact-information-row flex-child'>
              <Icon className='fa-phone' />
              {advisorContactCard.get('phone')}
            </div>
          )
        }
        {
          advisorContactCard.get('url') &&
          (
            <div className='contact-information-row flex-child'>
              <Icon className='fa-globe' />
              <a
                href={advisorContactCard.get('url')}
                rel='noreferrer'
                target='_blank'>
                Website
              </a>
            </div>
          )
        }
      </div>
    </div>
    {
      advisorContactCard.get('firm-type') !== 'funeral_home' &&
      <TextGutterMedium>
        If you would like to disassociate your account, please contact{' '}
        {advisorContactCard.get('name')}.
      </TextGutterMedium>
    }
  </BoxGutterMedium>
)

ProvidedByInformation.propTypes = {
  advisorContactCard: PropTypes.instanceOf(Map)
}

export default ProvidedByInformation
